<template>
  <b-modal ref="confirm-modal"
           modal-class="task-modal v2-modal"
           hide-footer
  >
    <template #modal-header>
      <div class="v2-modal__head">
        <div class="v2-modal__titles">
          <div class="v2-modal__eyebrow" v-if="eyebrow">{{ eyebrow }}</div>
          <h3>{{ title }}</h3>
        </div>
        <span class="task-panel__nav" @click="hide" :data-qid="qid + '-close'"><font-awesome-icon icon="times"/></span>
      </div>
    </template>

    <div class="v2-confirm" :data-qid="qid">
      <span class="v2-confirm__icon" :class="{'v2-confirm__icon--danger': danger}">
        <font-awesome-icon :icon="danger ? 'trash-alt' : 'info-circle'"/>
      </span>
      <div class="v2-confirm__text">
        <slot></slot>
      </div>
    </div>

    <div class="v2-modal__foot">
      <b-button variant="secondary" @click="hide" :data-qid="qid + '-cancel'">{{ $t('projects.create.cancel') }}</b-button>
      <b-button :variant="danger ? 'danger' : 'success'"
                :disabled="busy"
                @click="$emit('confirm')"
                :data-qid="qid + '-confirm'"
      >
        <font-awesome-icon v-if="busy"
                           icon="spinner"
                           size="sm"
                           class="fa-spin mr-1"
        />{{ confirmLabel }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
// Confirmation in the V2 dialog style, e.g. before deleting a task or a control objective
export default {
  name: 'EngagementConfirmModal',
  props: {
    title: {
      type: String,
      required: true
    },
    eyebrow: {
      type: String,
      default: ''
    },
    confirmLabel: {
      type: String,
      required: true
    },
    danger: {
      type: Boolean,
      default: true
    },
    busy: {
      type: Boolean,
      default: false
    },
    qid: {
      type: String,
      default: 'confirm-modal'
    }
  },
  methods: {
    show() {
      this.$refs['confirm-modal'].show();
    },
    hide() {
      this.$refs['confirm-modal'].hide();
    }
  }
};
</script>
